import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useTheme } from "@emotion/react";
import PropTypes from "prop-types";
import React from "react";
import extractTheme from "./extractTheme";
/**
 * ScrollableContainer is a React component that wraps the content with horizontal scrolling and a shadow.
 *
 */

import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";

function ScrollableContainer(props) {
  const theme = useTheme();
  const {
    cssRoot,
    scrollableContainerCSS,
    scrollableInnerContainerCSS,
    scrollableContainerContentCSS,
    scrollableContainerShadowCSS
  } = extractTheme({
    theme
  });

  const scrollableContainerStyles = _objectSpread(_objectSpread({}, cssRoot), scrollableContainerCSS);

  return _jsx("div", {
    css: scrollableContainerStyles,
    children: _jsxs("div", {
      css: scrollableInnerContainerCSS,
      children: [_jsx("div", {
        css: scrollableContainerContentCSS,
        children: props.children
      }), _jsx("span", {
        css: scrollableContainerShadowCSS
      })]
    })
  });
}

ScrollableContainer.propTypes = process.env.NODE_ENV !== "production" ? {
  /** This is what will be displayed inside the ScrollableContainer. */
  children: PropTypes.node.isRequired
} : {};
ScrollableContainer.displayName = "ScrollableContainer";
export default ScrollableContainer;